import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useForm, SubmitHandler } from "react-hook-form";
import { OptionType, AccountFormType, AccountType } from "../utils/GeneBoxAPI";
import MessageContext from "../Context/MessageContext";
import Modal from "../component/Modal";
import MultiSelect from "./MultiSelect";

const defaultValues: AccountFormType = {
    account: "",
    password: "",
    name: "",
    notes: "",
    download: [],
    read: [],
};

const AccountPage = () => {
    const history = useHistory();
    const {
        formState: { errors },
        register,
        handleSubmit,
        setValue,
        getValues,
        reset,
        control,
    } = useForm<AccountFormType>({ defaultValues });

    const [searchInput, setSearchInput] = useState("");
    const [accountList, setAccountList] = useState<AccountType[]>([]);
    const [accountListShow, setAccountListShow] = useState<AccountType[]>([]);
    const [options, setOptions] = useState<OptionType[]>([]);

    const [isShowModal, setIsShowModal] = useState(false);
    const [modalType, setModalType] = useState("");

    // message
    const { alertProps, setAlertProps, setIsAlert } =
        useContext(MessageContext);

    const onClose = () => {
        reset();
        setIsShowModal(false);
    };

    const onDelete = (row: AccountType) => {
        const index = accountList.findIndex(
            (item) => item.account === row.account
        );
        const newList = accountList.slice(0);
        newList.splice(index, 1);
        setAccountList(newList);
        setAccountListShow(newList);
        setSearchInput("");
    };

    const onSubmit: SubmitHandler<AccountFormType> = (data) => {
        const newData = {
            ...data,
            download: data.download.map((item) => item.value),
            read: data.read.map((item) => item.value),
        };
        if (modalType === "add") {
            const newList = [...accountList, newData];
            setAccountList(newList);
            setAccountListShow(newList);
        } else {
            const index = accountList.findIndex(
                (item) => item.account === newData.account
            );
            const newList = accountList.slice(0);
            newList[index] = newData;
            setAccountList(newList);
            setAccountListShow(newList);
        }
        onClose();
    };

    const getAccountList = () => {
        const data = [];
        for (let i = 1; i <= 5; i++) {
            data.push({
                account: `A2123${i.toString().padStart(2, "0")}@aaa.com.tw`,
                password: "test1234",
                name: "名字" + i,
                notes: "我是備註" + i,
                download: ["BA1", "BA2", "BA3"],
                read: ["BA6", "BA8"],
            });
        }
        setAccountList(data);
        setAccountListShow(data);
    };

    const getSupplierOptions = () => {
        const data = [];
        for (let i = 1; i <= 10; i++) {
            data.push({ value: `BA${i}`, label: `BA${i}` });
        }
        setOptions(data);
    };

    const handleDelete = (row: AccountType) => {
        setIsAlert(true);
        setAlertProps({
            ...alertProps,
            sub_title: `確定要刪除使用者${row.name}嗎？`,
            iMsg: 2,
            bBtnType: false,
            submitFun: () => onDelete(row),
        });
    };

    const handleSearch = () => {
        const newList = accountList.filter((item) => {
            return Object.values(item as any).some((value) =>
                String(value).includes(searchInput)
            );
        });
        setAccountListShow(newList);
    };

    const handleReturn = () => {
        history.goBack();
    };

    const handleAdd = () => {
        setModalType("add");
        setIsShowModal(true);
    };

    const handleEdit = (row: AccountType) => {
        const downloadList = row.download.map((item) => ({
            value: item,
            label: item,
        }));

        const readList = row.read.map((item) => ({
            value: item,
            label: item,
        }));
        setModalType("edit");
        setIsShowModal(true);

        setValue("name", row.name);
        setValue("account", row.account);
        setValue("password", row.password);
        setValue("notes", row.notes);
        setValue("download", downloadList);
        setValue("read", readList);
    };

    useEffect(() => {
        getAccountList();
        getSupplierOptions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const inputList = [
        {
            name: "account",
            type: "text",
            label: "帳號",
            setting: {
                required: { value: true, message: "此欄位必填" },
                pattern: {
                    value: /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/,
                    message: "請輸入正確的email格式",
                },
            },
        },
        {
            name: "password",
            type: "password",
            label: "密碼",
            setting: {
                required: { value: true, message: "此欄位必填" },
                minLength: { value: 8, message: "最少輸入八個字" },
            },
        },
        {
            name: "name",
            type: "text",
            label: "姓名",
            setting: {
                required: { value: true, message: "此欄位必填" },
            },
        },
        {
            name: "notes",
            type: "text",
            label: "備註",
        },
    ];

    const modalProps = {
        Md_Modal_title: <>{modalType === "add" ? "新增帳號" : "編輯帳號"}</>,
        Mdtitle: "",
        Mdcontent: (
                <form className="account_form">
                    {inputList.map(({ name, type, label, setting }) => (
                        <div key={name} className="dialog_form_item">
                            <label className="dialog_label" htmlFor={name}>
                                {label}
                                {setting && <span>*</span>}
                            </label>
                            <div className="dialog_row">
                                <input
                                    type={type}
                                    id={name}
                                    autoComplete="off"
                                    className="dialog_input"
                                    disabled={
                                        name === "account" &&
                                        modalType !== "add"
                                    }
                                    {...register(name, setting)}
                                />
                                {errors[name] && (
                                    <p className="error_text">
                                        {errors[name]?.message}
                                    </p>
                                )}
                            </div>
                        </div>
                    ))}
                    <MultiSelect
                        type="download"
                        options={options}
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                    />
                    <MultiSelect
                        type="read"
                        options={options}
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                    />
                </form>
        ),
        Mdtitle_bgcolor: "bg_blue_green",
        MdBtnType: 1,
        MdsubmitFun: () => handleSubmit(onSubmit)(),
        MdcloseFun: () => onClose(),
    };

    return (
        <>
            <div className="tab_content_1">
                <p className="tab_content_title">帳號管理</p>
                <div className="account_search_content">
                    <div className="search_input">
                        <input
                            type="text"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                        />
                    </div>
                    <div className="search_btn">
                        <button
                            className="button_style button_green"
                            onClick={handleSearch}
                        >
                            查詢
                        </button>
                        <button
                            className="button_style button_green"
                            onClick={handleAdd}
                        >
                            新增帳號
                        </button>

                        <span className="vertical_line text_grey">|</span>
                        <button
                            className="button_style button_green"
                            onClick={handleReturn}
                        >
                            返回
                        </button>
                    </div>
                </div>
                <div className="table_container">
                    <table className="list_table">
                        <thead>
                            <tr className="bg_blue_green">
                                <th>帳號</th>
                                <th>姓名</th>
                                <th>備註</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            {accountListShow.map((item) => {
                                return (
                                    <tr key={item.account}>
                                        <td>{item.account}</td>
                                        <td className="width-20">
                                            {item.name}
                                        </td>
                                        <td className="width-20">
                                            {item.notes}
                                        </td>
                                        <td className="width-20">
                                            <button
                                                className="button_style button_yellow"
                                                onClick={() => handleEdit(item)}
                                            >
                                                編輯
                                            </button>
                                            <button
                                                className="button_style button_red"
                                                onClick={() =>
                                                    handleDelete(item)
                                                }
                                            >
                                                刪除
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                {isShowModal && <Modal {...modalProps} />}
            </div>
        </>
    );
};

export default AccountPage;
